import styled, { css } from 'styled-components';
import { Dropdown } from '@/components/UI/Dropdown';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const SearchRegionDropdownBox = styled(Dropdown).attrs({
  alignment: 'left',
  hasOverlay: false,
})``;

export const SearchRegionDropdownMenuWrapper = styled.div`
  width: 176px;
  margin: 1px 0 0 1px;
  padding: 10px 0;
  background: ${({ theme }) => theme.palette.primary.background};
  border-radius: 14px;

  @media (min-width: 1025px) {
    width: 232px;
  }
`;

export const SearchRegionDropdownMenu = styled.div`
  height: auto;
  max-height: 294px;
  padding: 0 10px;
  overflow-y: auto;
`;

export const SearchRegionDropdownItem = styled(Typography.Body)<{
  $isSelected?: boolean;
  $isNotFound?: boolean;
}>`
  display: flex;
  align-items: center;
  width: 100%;
  height: 43.5px;
  padding: 0 10px;
  border-radius: 14px;
  background-color: ${({ theme }) => theme.palette.primary.background};
  color: ${({ $isSelected, theme }) =>
    $isSelected ? theme.palette.brand.main : theme.palette.primary.labels};

  ${({ $isNotFound }) =>
    $isNotFound
      ? css`
          padding: 0;
          height: auto;
          color: ${({ theme }) => theme.palette.quartenary.labels};
        `
      : css`
          cursor: pointer;

          &:hover {
            background-color: ${({ theme }) =>
              theme.palette.quartenary.background};
            color: ${({ theme }) => theme.palette.brand.main};
          }
        `}
`;
